import styled from "styled-components";

import FallbackImage from "components/global/FallbackImage";

export const SchoolsSectionGridLayout = styled.div.attrs({
  className: "grid gap-6 xl:grid-cols-[0.95fr_1.05fr]",
})``;

export const SchoolOverviewStack = styled.div.attrs({
  className: "grid gap-6",
})``;

export const SchoolOverviewContentStack = styled.div.attrs({
  className: "grid gap-8",
})``;

export const SchoolOverviewHeroRow = styled.div.attrs({
  className: "flex flex-col gap-4 sm:flex-row sm:items-center",
})``;

export const SchoolOverviewHeroImage = styled(FallbackImage).attrs({
  className:
    "h-16 w-16 shrink-0 rounded-[22px] border border-[var(--brand-border)] bg-[rgba(255,255,255,0.04)] shadow-[0_12px_20px_rgba(0,0,0,0.18)] sm:h-20 sm:w-20",
})``;

export const SchoolOverviewHeroTextGroup = styled.div.attrs({
  className: "min-w-0 flex-1",
})``;

export const SchoolOverviewHeroEyebrow = styled.p.attrs({
  className: "font-anonymous text-xs uppercase tracking-[0.22em] text-[var(--brand-highlight)]",
})``;

export const SchoolOverviewHeroTitle = styled.h3.attrs({
  className: "mt-2 text-xl font-semibold text-[var(--brand-ink)] sm:text-2xl",
})``;

export const SchoolOverviewHeroMeta = styled.p.attrs({
  className: "mt-1 text-sm leading-6 text-[var(--brand-muted)]",
})``;

export const SchoolOverviewBadgeRow = styled.div.attrs({
  className: "mt-3 flex flex-wrap items-center gap-2",
})``;

export const SchoolOverviewSection = styled.section.attrs({
  className: "space-y-3",
})``;

export const SchoolOverviewSectionHeading = styled.h4.attrs({
  className: "text-sm font-semibold tracking-wide text-[var(--brand-ink)]",
})``;

export const SchoolOverviewMetadataGrid = styled.div.attrs({
  className: "grid gap-3 sm:grid-cols-2 xl:grid-cols-3",
})``;

export const SchoolOverviewMetadataTile = styled.div.attrs({
  className: "brand-panel-muted rounded-[18px] px-4 py-3.5",
})``;

export const SchoolOverviewEyebrowText = styled.p.attrs({
  className: "text-[11px] uppercase tracking-[0.18em] text-[var(--brand-muted)]",
})``;

export const SchoolOverviewTitleText = styled.p.attrs({
  className: "mt-1.5 text-base font-medium leading-snug text-[var(--brand-ink)]",
})``;

export const SchoolOverviewStatsGrid = styled.div.attrs({
  className: "grid gap-3 sm:grid-cols-3",
})``;

export const SchoolOverviewStatCard = styled.div.attrs({
  className:
    "flex items-start gap-3 rounded-[20px] border border-[var(--brand-border)] bg-[rgba(255,255,255,0.03)] px-4 py-4",
})``;

export const SchoolOverviewStatIcon = styled.span.attrs({
  className:
    "inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-2xl border border-[rgba(240,191,86,0.22)] bg-[rgba(240,191,86,0.1)] text-[var(--brand-highlight)]",
})``;

export const SchoolOverviewStatBody = styled.div.attrs({
  className: "min-w-0",
})``;

export const SchoolOverviewStatValue = styled.p.attrs({
  className: "mt-1 text-2xl font-semibold leading-none text-[var(--brand-ink)]",
})``;

export const SchoolOverviewBrandBlock = styled.div.attrs({
  className: "space-y-3",
})``;

export const SchoolOverviewBrandStrip = styled.div.attrs({
  className: "grid gap-3 sm:grid-cols-3",
})``;

export const SchoolOverviewBrandSwatchCard = styled.div.attrs({
  className:
    "overflow-hidden rounded-[20px] border border-[var(--brand-border)] bg-[rgba(255,255,255,0.03)]",
})``;

export const SchoolOverviewBrandSwatch = styled.div<{ $color: string }>`
  background: ${({ $color }) => $color};
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  height: 4.5rem;
  width: 100%;
`;

export const SchoolOverviewBrandSwatchLabel = styled.p.attrs({
  className: "px-3.5 py-2.5 text-sm font-medium text-[var(--brand-ink)]",
})``;

export const SchoolOverviewBrandThemeNote = styled.p.attrs({
  className: "text-sm text-[var(--brand-muted)]",
})``;

export const SchoolOverviewEditButton = styled.button.attrs({
  className:
    "inline-flex items-center justify-center gap-2 rounded-2xl bg-[var(--brand-highlight)] px-4 py-2.5 text-sm font-semibold text-[#1b1306] transition hover:bg-[var(--brand-accent-deep)] hover:text-white",
})``;
